import React from 'react'
import DocumentTitle from 'react-document-title'
import {Link} from 'react-router-dom'

import {withStyles, Grid, Typography, Card, CardContent, Button} from 'material-ui'


const styles = theme => ({
    container: {
        zIndex: 1,
        position: 'relative',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
        margin: "0 auto",
        background: "lightergray",
    },
    content: {
        padding: 20,
        maxWidth: theme.layout.contentWidth,
        margin: "0 auto",
        marginBottom: 60,
        '& h1': theme.typography.display1,
        '& h2': theme.typography.headline,
        '& h3': theme.typography.subheading,
        '& p': theme.typography.body1,
    },
    grow: {
        flex: 1
    },
    priceFormat: {
        display: "inline-block",
    },
    priceMargins: {
        marginTop: "1em",
        marginBottom: "1em",
    },
    featuredPrice: {
        marginTop: "-1em",
        minHeight: "12em",
        backgroundColor: "#394963",
    },
    topSpace: {
        marginTop: "2em",
    },
    bottomSpace: {
        marginBottom: "2em",
    },
    card: {
        maxWidth: 345,
    },
    cardContent: {
        minHeight: "10em",
    }
})

export const Plans = withStyles(styles)(
    ({classes}) => (
    <div className={classes.container}>
        <div className={classes.content}>
            <Grid container spacing={24}>
                <Grid item xs={12}>
                    <Typography
                        component="h1"
                        align="center"
                        className={classes.topSpace}
                        style={{color:"black"}}><strong>Plans built for everyone</strong></Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography
                        component="h2"
                        align="center"
                        className={classes.bottomSpace}
                        style={{color:"black"}}>With plans for families, individuals, and professionals, choose the plan that fits your needs.</Typography>
                </Grid>
                <Grid item sm={3}>
                    <PlanCard
                        price="$0"
                        interval="/month"
                        title="FREE"
                        text="Full access to contacts, tasks, calendar, medicines, files, and resources."
                        color="#0867C8"/>
                </Grid>
                <Grid item sm={3}>
                    <PlanCard
                        price="$14.99"
                        interval="/month"
                        title="FAMILY"
                        text="All FREE plan features + private voicemail and indexing of uploads."
                        color="black"/>
                </Grid>
                <Grid item sm={3}>
                    <FeaturedPlanCard
                        price="$149.99"
                        interval="/month"
                        title="DELUXE"
                        text="All FAMILY plan features + ongoing access to an Aging Life Care Professional."
                        color="white"/>
                </Grid>
                <Grid item sm={3}>
                    <PlanCard
                        price="Get Quote"
                        interval=""
                        title="PROFESSIONAL"
                        text="All DELUXE features + integration with leading electronic health records."
                        color="black"/>
                </Grid>
            </Grid>
        </div>
    </div>
    )
)

export const PlanCard = withStyles(styles) (
    ({classes, color, image, price, interval, title, text}) => (

        <Card className={classes.card} raised={false}>
            <CardContent className={classes.cardContent}>
                <Typography align="center" className={classes.priceMargins}>
                    <Typography
                        className={classes.priceFormat}
                        component="h1"
                        style={{color: "#0867C8", fontFamily: "lato"}}>
                        <strong>{price}</strong>
                    </Typography>
                    <Typography className={classes.priceFormat} component="h3">{interval}</Typography>
                </Typography>
                <Typography gutterBottom component="h3" align="center" style={{color: color}}>
                    <strong>{title}</strong>
                </Typography>
                <Typography component="p" align="center">
                    {text}
                </Typography>
            </CardContent>
        </Card>
    )
)

export const FeaturedPlanCard = withStyles(styles) (
    ({classes, color, image, price, interval, title, text}) => (

        <Card className={classes.card} raised={true}>
            <CardContent className={classes.featuredPrice}>
                <Typography align="center" className={classes.priceMargins}>
                    <Typography
                        className={classes.priceFormat}
                        component="h1"
                        style={{color: "#0867C8", fontFamily: "lato"}}><strong>{price}</strong>
                    </Typography>
                    <Typography className={classes.priceFormat} component="h3" style={{color: "white"}}>{interval}</Typography>
                </Typography>
                <Typography gutterBottom component="h3" align="center" style={{color: color}}>
                    <strong>{title}</strong>
                </Typography>
                <Typography component="p" align="center" style={{color: "white"}}>
                    {text}
                </Typography>
                <Typography component="p" align="center" style={{marginTop: "2em"}}>
                    <Button component={Link} to="/signup" style={{backgroundColor: "lightgreen", borderRadius: 25}}>
                        <span style={{paddingTop: 3}}>Try Free For 30 days</span>
                    </Button>
                </Typography>
            </CardContent>
        </Card>
    )
)

export default Plans


// WEBPACK FOOTER //
// ./src/components/Plans.jsx